import { TextLink } from '@oneaudi/unified-web-alpha-components';
import { useCallback, useState } from 'react';
import { useI18n } from '~/app/i18n/i18n';
import { appTrackingService } from '~/app/tracking/app-tracking-service';
import { EventAction, LayerType } from '~/app/tracking/feld-m-types';
import { Dialog } from '~/components/dialog';
import { CatalogItemType } from '~/graphql/types';
import { CompareLayerWrapper } from '../compare-layer-wrapper';

export function ModelTechnicalDataDialog({
	driveTrain,
	trackSelection,
	step,
	total,
	hasSingleTrimlineAndEngine,
}: {
	driveTrain: CatalogItemType['driveTrain'];
	trackSelection?: () => void;
	step: number;
	total: number;
	hasSingleTrimlineAndEngine?: boolean;
}) {
	const { i18n } = useI18n();
	const [open, setOpen] = useState(false);

	function onAddToConfiguration() {
		if (trackSelection) {
			trackSelection();
		}
	}

	const onOpen = useCallback(
		(_open: boolean) => {
			appTrackingService.trackSelectionClickEvent({
				eventAction: EventAction.InternalLink,
				eventName: `click to ${_open ? 'open' : 'close'} ${LayerType.TechnicalDataLayer}`,
				label: i18n('ngc.actions.technicalData'),
				elementName: 'text link',
				value: 'technical data',
				category: 'engine',
				elementCurrentStep: step,
				elementTotalSteps: total,
				item: driveTrain,
			});
			setOpen(_open);

			appTrackingService.updateLayerComponent(LayerType.TechnicalDataLayer, _open ? 'open' : 'close');

			appTrackingService.viewChangeEvent({
				eventName: _open ? `configurator - ${LayerType.TechnicalDataLayer}` : 'generic',
				componentName: _open ? 'selections' : undefined,
			});
		},
		[driveTrain, i18n, step, total],
	);

	return (
		<Dialog
			open={open}
			onCloseButtonClick={() => onOpen(false)}
			triggerElement={
				<TextLink variant={'standalone'} size={'sm'} onClick={() => onOpen(true)}>
					{i18n('ngc.actions.technicalData')}
				</TextLink>
			}>
			{open && (
				<CompareLayerWrapper
					setIsOpen={setOpen}
					open={open}
					actions={{
						onAddToConfiguration,
					}}
					key="technical-data-dialog"
					selectedDriveTrain={driveTrain}
					config={{
						selectedTab: 'technicalData',
						isDisabled: hasSingleTrimlineAndEngine,
					}}
				/>
			)}
		</Dialog>
	);
}
